/** @file keydown: updates modifiers, then (outside inputs and IME) tracks the held key and fires hold-down. */
import { isTypingTarget } from '../isTypingTarget';
import type { KeySourceEvent } from '../keyTarget';
import { dispatchBinding } from './dispatchBinding';
import { fireHolds } from './fireHolds';
import { keyState } from './keyState';
import { updateModifiers } from './updateModifiers';

/** Ignores IME composition and text-entry targets; `preventDefault` only for a claimed hold key or a bound chord. */
export function handleKeyDown(event: KeySourceEvent): void {
  updateModifiers(event);
  if (event.isComposing || isTypingTarget(event.target)) return;
  const wasHeld = keyState.held.has(event.code);
  keyState.held.add(event.code);
  if (keyState.holds.some((h) => h.code === event.code)) event.preventDefault();
  if (!wasHeld) fireHolds(event.code, 'down');
  dispatchBinding(event);
}
